import { render, staticRenderFns } from "./BottomRightCallInfo.vue?vue&type=template&id=45458ff6&scoped=true"
import script from "./BottomRightCallInfo.vue?vue&type=script&lang=js"
export * from "./BottomRightCallInfo.vue?vue&type=script&lang=js"
import style0 from "./BottomRightCallInfo.vue?vue&type=style&index=0&id=45458ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45458ff6",
  null
  
)

export default component.exports